// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3wU9d","footer":"ChangeClinic_footer__1nBUZ"};